var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuyshocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #99cfe2;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #121628;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70,140C31.53,140,0,108.47,0,70S31.53,0,70,0s70,31.53,70,70-31.53,70-70,70ZM70,3.78C33.42,3.78,4.41,33.42,4.41,69.37s29.64,65.59,65.59,65.59,65.59-29.64,65.59-65.59S105.95,3.78,70,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70,68.41c-8.98,0-16.28-7.3-16.28-16.28s7.3-16.28,16.28-16.28,16.28,7.3,16.28,16.28-7.3,16.28-16.28,16.28ZM70,36.85c-8.42,0-15.28,6.85-15.28,15.28s6.85,15.28,15.28,15.28,15.28-6.85,15.28-15.28-6.85-15.28-15.28-15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70,105.48c-13.73,0-25.56-9.32-28.75-22.67l-.03-.12.03-.12c1.94-8.13,7.26-15.09,14.61-19.1l.44-.24.24.44c2.67,4.97,7.83,8.05,13.46,8.05s10.79-3.09,13.46-8.05l.24-.44.44.24c7.35,4.01,12.67,10.97,14.61,19.1l.03.12-.03.12c-3.19,13.34-15.02,22.67-28.75,22.67ZM42.25,82.7c3.12,12.83,14.52,21.78,27.75,21.78s24.62-8.95,27.75-21.78c-1.85-7.65-6.81-14.21-13.65-18.1-2.91,5.03-8.26,8.14-14.1,8.14s-11.19-3.1-14.1-8.14c-6.84,3.89-11.8,10.45-13.65,18.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.19,31.32c0,.95-.11,2.12-.26,4.08l-1.48,17.44c-.19.64-1.27.64-1.43,0l-1.48-17.44c-.16-1.96-.26-3.13-.26-4.08,0-1.32.48-2.65,2.46-2.65s2.46,1.32,2.46,2.65ZM89.79,57.01c0-1.15.84-2,1.93-2s1.95.84,1.95,2-.84,2-1.95,2-1.93-.82-1.93-2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyshocked);
export default __webpack_public_path__ + "static/media/guyshocked.6aab853f36e06d3e661f653cbbd65c4f.svg";
export { ForwardRef as ReactComponent };